const SERVICE_DATA = {
    heading: "¿Qué es CONECTA?",
    
    description: "Conecta es la Plataforma en la nube del Consejo General de Colegios de Administradores de Fincas de España (CGCAFE) para el intercambio de información entre proveedores y administradores de fincas colegiados.",
    services_list: [{
            key: 1,
            label: "¿Qué es CONECTA?",
            text: "Es la plataforma en la nube del Consejo General de Colegios de Administradores de fincas de España (CGCAFE) para el intercambio de información entre proveedores y administradores de fincas colegiados. Tiene como objetivo el establecimiento de un canal de comunicación seguro y eficaz que sea beneficioso para ambas partes.",
            icon: "pe-7s-search"
        },
        {
            key: 2,
            label: "¿Por qué usar Conecta?",
            text: "Permitirá a los proveedores de cualquier sector enviar de forma directa y rápida documentos e información (Facturas, presupuestos, contratos, datos de instalaciones, etc.) a los Administradores de Fincas, agilizando y simplificando de forma significativa el trabajo de recopilar y archivar facturas y otros documentos, y una gran ventana de mercado para los proveedores al comunicarles con cientos de comunidades y Administradores de Fincas.",
            icon: "pe-7s-tools"
        },
        {
            key: 3,
            label: "La seguridad es lo primero",
            text: "Uno de los principales objetivos de la plataforma es garantizar la seguridad de las comunicaciones y la integridad de los datos. Para ello se utilizan protocolos de comunicación cifrados SSL en todos los procesos de intercambio de información y tecnologías de aislamiento de información que garantizan que el único destinatario de los datos sea, en efecto, el cliente final.",
            icon: "pe-7s-safe"
        },
        {
            key: 4,
            label: "Un proyecto en evolución",
            text: "La Plataforma Conecta es un proyecto vivo en contínuo desarollo que busca cubir las necesidades presentes y futuras de los Administradores de Fincas Colegiados.",
            icon: "pe-7s-science"
        },
    ]
};

const FEATURES_DATA = {
    title: 'A digital web design studio creating modern & engaging online',
    text: 'Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.',
    feature_list: [
        'We put a lot of effort in design.',
        'The most important ingredient of successful website.',
        'Submit Your Orgnization.'
    ]
};

const WEBSITE_DESCRIPTION = {
    title: 'Plataforma Conecta',
    text: 'Conecta es la Plataforma en la nube del Consejo General de Colegios de Administradores de Fincas de España (CGCAFE) para el intercambio de información entre proveedores y administradores de fincas colegiados.',
    buttontext: 'Más información'
};

const PRICING_DATA = {
    title: 'Our Pricing',
    description: 'Call to action pricing table is really crucial to your for your business website. Make your bids stand-out with amazing options.',
    pricing_list: [
        {
            title: 'Economy',
            price: '$9.90',
            bandwidth: '1GB',
            onlinespace: '50MB',
            support: 'No',
            domain: 1,
            hiddenfees: 'No'
        },
        {
            title: 'Delux',
            price: '$19.90',
            bandwidth: '10GB',
            onlinespace: '500MB',
            support: 'Yes',
            domain: 10,
            hiddenfees: 'No'
        },
        {
            title: 'Unlimate',
            price: '$29.90',
            bandwidth: '100GB',
            space: '2 GB',
            support: 'Yes',
            domain: 'Unlimited',
            hiddenfees: 'No'
        }
    ]
};

const TEAM_DATA = {
        title: 'Behind The People',
        description: 'It is a long established fact that create category leading brand experiences a reader will be distracted by the readable content of a page when looking at its layout.',
        team_list: [
            {
                profile: '/images/team/img-1.jpg',
                name: 'Frank Johnson',
                designation: 'CEO'
            },
            {
                profile: '/images/team/img-2.jpg',
                name: 'Elaine Stclair',
                designation: 'Designer'
            },
            {
                profile: '/images/team/img-3.jpg',
                name: 'Wanda Arthur',
                designation: 'Developer'
            },
            {
                profile: '/images/team/img-4.jpg',
                name: 'Joshua Stemple',
                designation: 'Manager'
            }
        ]
}

const TESATIMONIAL_DATA = {
    title :"What they've said",
    description: "The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious Semikoli.",
    testimonial_list: [
        {
            profile: 'images/testimonials/user-1.jpg',
            description: "I feel confident imposing change on myself. It's a lot more fun progressing than looking back. That's why I ultricies enim at malesuada nibh diam on tortor neaded to throw curve balls.",
            name: 'Dennis Williams - ',
            text: 'Charleston'
        },
        {
            profile: 'images/testimonials/user-2.jpg',
            description: "Our task must be to free ourselves by widening our circle of compassion to embrace all living creatures and the whole of quis consectetur nunc sit amet semper justo.nature and its beauty.",
            name: 'Laurie Bell - ',
            text: 'Worcester'
        },
        {
            profile: 'images/testimonials/user-3.jpg',
            description: "I've learned that people will forget what you said, people will forget what you did,but people will never forget how donec in efficitur lectus, nec lobortis metus you made them feel.",
            name: 'Howard Kelley - ',
            text: 'Lynchburg'
        }
    ]
}

const GET_STARTED = {
    newtitle: "Let's Get Started",
    newtext: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.',
    newbuttontext: 'Get Started'
};

const BLOG_DATA = {
    title :'Latest News',
    description: 'Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean class at a euismod mus luctus quam.',
    blog_list:[
        {
            image: 'images/blog/img-1.jpg',
            text: 'UI & UX Design',
            title: 'Doing a cross country road trip',
            subtext: 'She packed her seven versalia, put her initial into the belt and made herself on the way..'
        },
        {
            image: 'images/blog/img-2.jpg',
            text: 'Digital Marketing',
            title: 'New exhibition at our Museum',
            subtext: 'Pityful a rethoric question ran over her cheek, then she continued her way.'
        },
        {
            image: 'images/blog/img-3.jpg',
            text: 'Travelling',
            title: 'Why are so many people..',
            subtext: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.'
        }
    ]
}

const MOCK_DATA = {
    SERVICE_DATA,
    FEATURES_DATA,
    GET_STARTED,
    WEBSITE_DESCRIPTION,
    PRICING_DATA,
    TEAM_DATA,
    TESATIMONIAL_DATA,
    BLOG_DATA
}

export default MOCK_DATA;